/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CompanyLegalIdentifierResource
 */
export interface CompanyLegalIdentifierResource {
    /**
     * 
     * @type {string}
     * @memberof CompanyLegalIdentifierResource
     */
    registrationNumber: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyLegalIdentifierResource
     */
    registrationNumberType: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyLegalIdentifierResource
     */
    countryCode: string;
    /**
     * Region/sub-jurisdiction code. Present iff this is a regional identifier (e.g. German Bezirk).
     * @type {string}
     * @memberof CompanyLegalIdentifierResource
     */
    regionCode?: string;
}

/**
 * Check if a given object implements the CompanyLegalIdentifierResource interface.
 */
export function instanceOfCompanyLegalIdentifierResource(value: object): value is CompanyLegalIdentifierResource {
    if (!('registrationNumber' in value) || value['registrationNumber'] === undefined) return false;
    if (!('registrationNumberType' in value) || value['registrationNumberType'] === undefined) return false;
    if (!('countryCode' in value) || value['countryCode'] === undefined) return false;
    return true;
}

export function CompanyLegalIdentifierResourceFromJSON(json: any): CompanyLegalIdentifierResource {
    return CompanyLegalIdentifierResourceFromJSONTyped(json, false);
}

export function CompanyLegalIdentifierResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanyLegalIdentifierResource {
    if (json == null) {
        return json;
    }
    return {
        
        'registrationNumber': json['registrationNumber'],
        'registrationNumberType': json['registrationNumberType'],
        'countryCode': json['countryCode'],
        'regionCode': json['regionCode'] == null ? undefined : json['regionCode'],
    };
}

export function CompanyLegalIdentifierResourceToJSON(value?: CompanyLegalIdentifierResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'registrationNumber': value['registrationNumber'],
        'registrationNumberType': value['registrationNumberType'],
        'countryCode': value['countryCode'],
        'regionCode': value['regionCode'],
    };
}

